import { render } from "./rx-used-status.vue?vue&type=template&id=9713ffce&scoped=true"
import script from "./rx-used-status.vue?vue&type=script&lang=js"
export * from "./rx-used-status.vue?vue&type=script&lang=js"

import "./rx-used-status.vue?vue&type=style&index=0&id=9713ffce&lang=scss&scoped=true"

import exportComponent from "/builds/gitlab-runner/ci/auto-build/hospital-user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9713ffce"]])

export default __exports__